import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { MeterMediaType } from './const/enums';
import { ConsumptionMeterModel } from './consumption-meter-model';

export class Meter extends ModelBase {
  meterType: MeterMediaType;
  name: string;
  manufacturer: string;
  meterTypeCaption: string;
  imdMeterModelId: string;
  imdPriceListName: string;
  toString(culture?: string): string {
    return this.name;
  }
}
